import { Alert, Col, Divider, Form, FormInstance, Input, Row, Select, Space, Typography } from 'antd';
import useFetchData from '../../../../hooks/useFetchData';
import { CounterpartyFormDto } from '../../../../interfaces/CounterpartyDtos';
import { CounterpartyService } from '../../../../services/CounterpartyService';

export interface CounterpartyFormProps {
    form: FormInstance<any>;
    onFinish: (values: any) => void;
}

const CounterpartyForm = ({ form, onFinish }: CounterpartyFormProps) => {
    const { data: forms } = useFetchData<CounterpartyFormDto[]>(CounterpartyService.getCounterpartyForms, true);

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
        >
            <Form.Item
                label="БИН"
                name="bin"
                rules={[
                    { required: true, message: 'БИН должен состоять из 12 цифр и не должен быть пустым!' },
                    { len: 12, message: 'БИН должен состоять из 12 цифр!' },
                    { pattern: /^[0-9]{12}$/, message: 'БИН должен состоять только из цифр!' }
                ]}
            >
                <Input maxLength={12} />
            </Form.Item>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item
                        label="Наименование на казахском"
                        name="nameKz"
                        rules={[{ required: true, message: 'Пожалуйста, введите наименование на казахском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Наименование на русском"
                        name="nameRu"
                        rules={[{ required: true, message: 'Пожалуйста, введите наименование на русском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Наименование на английском"
                        name="nameEn"
                        rules={[{ required: true, message: 'Пожалуйста, введите наименование на английском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Alert
                message={
                    <Space direction="vertical">
                        <Typography.Text>{'Пример заполнения адреса: Г.АСТАНА, РАЙОН АЛМАТЫ, улица А 108, дом 20, кв. 144'}</Typography.Text>
                        <Typography.Text>{' Нужно заполнить на трех языках, если нет адреса на английском, то оставить пустым.'}</Typography.Text>
                    </Space>
                }
                type="info"
                style={{ marginBottom: 16 }}
            />
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item
                        label="Адрес на казахском"
                        name="addressKz"
                        rules={[{ required: true, message: 'Пожалуйста, введите адрес на казахском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Адрес на русском"
                        name="addressRu"
                        rules={[{ required: true, message: 'Пожалуйста, введите адрес на русском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Адрес на английском"
                        name="addressEn"
                    // rules={[{ required: true, message: 'Пожалуйста, введите адрес на английском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Divider />
            <Form.Item
                label="ФИО руководителя"
                name="headFullname"
                rules={[{ required: true, message: 'Пожалуйста, введите ФИО руководителя!' }]}
            >
                <Input />
            </Form.Item>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item
                        label="Должность руководителя на казахском"
                        name="headPositionKz"
                        rules={[{ required: true, message: 'Пожалуйста, введите должность руководителя на казахском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Должность руководителя на русском"
                        name="headPositionRu"
                        rules={[{ required: true, message: 'Пожалуйста, введите должность руководителя на русском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Должность руководителя на английском"
                        name="headPositionEn"
                        rules={[{ required: true, message: 'Пожалуйста, введите должность руководителя на английском!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                label="ФИО представителя"
                name="representativeFullname"
                rules={[{ required: true, message: 'Пожалуйста, введите ФИО представителя!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Телефон представителя"
                name="representativePhoneNumber"
                rules={[{ required: true, message: 'Пожалуйста, введите телефон представителя!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: 'Пожалуйста, введите email!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Форма собственности"
                name="counterPartyFormId"
                rules={[{ required: true, message: 'Пожалуйста, выберите форму собственности!' }]}
            >
                <Select
                    options={forms?.map(form => ({ label: form.longNameRu, value: form.id }))}
                />
            </Form.Item>
        </Form >
    )
}

export default CounterpartyForm